module.exports = __webpack_public_path__ + "static/media/480.8844d99c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-move-shit-around/dark/480.png
// module id = 2254
// module chunks = 2